export default {
  'pages.index.title': 'Liulian AI - Precision Visual Experience',
  'pages.index.brand': 'Liulian AI',
  'pages.index.nav.customer': 'Support',
  'pages.index.nav.developer': 'Developers',
  'pages.index.nav.register': 'Sign up',
  'pages.index.nav.login': 'Sign in',
  'pages.index.nav.workbench': 'Workbench',
  'pages.index.badge': '✦ NEXT-GEN AI PLATFORM',
  'pages.index.hero.titleLine1': 'Let AI help you',
  'pages.index.hero.typewriter.0': 'unlock inspiration',
  'pages.index.hero.typewriter.1': 'generate images',
  'pages.index.hero.typewriter.2': 'create videos',
  'pages.index.hero.typewriter.3': 'make comics in one click',
  'pages.index.hero.typewriter.4': 'chat intelligently',
  'pages.index.hero.subtitle':
    'Top global models in one place — from idea to output in seconds.<br>One platform for every possibility of an intelligent future.',
  'pages.index.hero.cta.primary': 'Get Started',
  'pages.index.hero.cta.business': 'Business',
  'pages.index.stats.models': 'Models',
  'pages.index.stats.creators': 'Creators',
  'pages.index.stats.idea': 'Ideas',
  'pages.index.agents.eyebrow': 'AI AGENTS',
  'pages.index.agents.title': 'More than tools — your creative partner',
  'pages.index.agents.subtitle':
    'From text to video, from spark to finished work — AI agents handle the full pipeline, 10× faster.',
  'pages.index.agent.video.title': 'One-click video',
  'pages.index.agent.video.desc':
    'Paste a script or reference frames — AI splits shots, generates characters, voice, and assembles the video end to end.',
  'pages.index.agent.longVideo.title': 'Long-form video',
  'pages.index.agent.longVideo.desc':
    'Reference frames plus prompts for precise control of content and duration — coherent, pro-grade long videos.',
  'pages.index.agent.style.title': 'Instant style switch',
  'pages.index.agent.style.desc':
    'Cyberpunk, ink wash, 3D, cinematic realism — switch styles freely with no creative limits.',
  'pages.index.agent.voice.title': 'Auto voice sync',
  'pages.index.agent.voice.desc':
    'Smart TTS matched to visuals — narration or drama modes so your content sounds alive.',
  'pages.index.agent.cta': 'Try now →',
  'pages.index.platform.eyebrow': 'PLATFORM',
  'pages.index.platform.title': 'Four core capabilities, one platform',
  'pages.index.platform.chat.title': 'Smart chat',
  'pages.index.platform.chat.desc':
    'GPT-4o / Claude / Gemini / DeepSeek — switch models freely for precise answers.',
  'pages.index.platform.image.title': 'Image creation',
  'pages.index.platform.image.desc':
    'Midjourney / FLUX / Jimeng / DALL·E — text to image in realistic, illustrative, or 3D styles.',
  'pages.index.platform.video.title': 'Video generation',
  'pages.index.platform.video.desc':
    'Sora 2 / Kling / Luma / Veo / Runway — text or image to cinematic video in one click.',
  'pages.index.platform.tts.title': 'Voice synthesis',
  'pages.index.platform.tts.desc':
    'Multilingual, multi-voice dubbing from narration to dialogue — studio-grade sound.',
  'pages.index.footer.copyright':
    '© 2024 Liulian AI Technology Co., Ltd. All Rights Reserved.',
  'pages.index.product.gpt4o.desc': 'Top-tier reasoning',
  'pages.index.product.claude.desc': 'Human-like writing',
  'pages.index.product.midjourney.desc': 'Art-grade imagery',
  'pages.index.product.sora.desc': 'Video breakthrough',
  'pages.index.product.deepseek.desc': 'Strongest reasoning',
  'pages.index.product.flux.desc': 'Detail master',
};
